import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatMessageTimestamp } from '../../../../../utils/formatTime';
import { ICorporateEventMessage } from '../../../../../interfaces/corporateEvent';
import { MAX_UNREAD_MESSAGE_COUNT } from '../../../../../constants/commonConstants';
import MentionBadge from '../../../../SendBird/MentionBadge/MentionBadge';
import { shouldShowMentionBadge } from '../../../../../utils/sendbird/chatAccessibility';
import './MessageListItem.scss';

interface IMessageListItemProps {
  message: ICorporateEventMessage;
  onClick?: (messageId: string) => void;
}

const MessageListItem: React.FC<IMessageListItemProps> = ({ message, onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick(message.corporateEventVendorId);
    }
  };

  const renderUnreadBadge = () => {
    if (!message.unreadMessageCount || message.unreadMessageCount === 0) {
      return null;
    }

    return (
      <Box className="messageUnreadBadge">
        <Typography className="messageUnreadBadgeText">
          {message.unreadMessageCount > MAX_UNREAD_MESSAGE_COUNT ? `${MAX_UNREAD_MESSAGE_COUNT}+` : message.unreadMessageCount}
        </Typography>
      </Box>
    );
  };

  return (
    <Box
      className={`messageListItem ${message.unreadMessageCount ? 'unread' : ''}`}
      onClick={handleClick}
    >
      <Box className="messageListItemContainer">
        <Box className="messageAvatarMargin">
          <Box className="messageAvatarBackground" sx={{ backgroundColor: message.logoBackgroundColor }}>
            <Box className="messageAvatarInner">
              <Typography className="messageAvatarText">
                YC
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box className="messageContentContainer">
          <Box className="messageHeaderContainer">
            <Box className="messageVendorNameContainer">
              <Typography className={`messageVendorName ${!message.lastMessage ? 'startChat' : ''}`}>
                YouCater Corporate Requests
              </Typography>
            </Box>
            <Box className="messageTimestampContainer">
              <Typography className="messageTimestamp">
                {message.lastMessageAt ? formatMessageTimestamp(message.lastMessageAt) : ''}
              </Typography>
            </Box>
          </Box>
          <Box className="messagePreviewContainer">
            <Box className="messageTextContainer">
              <Typography className={`messagePreviewText ${!message.lastMessage ? 'startChat' : ''}`}>
                {message.lastMessage || 'Tap to chat with YouCater Admin'}
              </Typography>
            </Box>
            <Box className="messageRowBadges">
              {shouldShowMentionBadge(message) ? <MentionBadge /> : null}
              {renderUnreadBadge()}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MessageListItem;
